import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import {
  Card,
  Flex,
  ProgressSlider,
  Statistic,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { ThemeColors } from '@monorepo/types';
import DashboardTooltip from '../../dashboard-common/dashboard-tooltip/dashboard-tooltip';

import '../progress-cards-5ers/progress-cards.scss';

interface Props {
  target: number;
  base: number;
  profitAndLoss: number;
}

const ProfitTargetTtp: FunctionComponent<Props> = ({
  target,
  base = 0,
  profitAndLoss,
}) => {
  const { isMobile } = useResponsiveness();
  const { t } = useTranslation(['dashboardTemplates']);

  const displayProfitAndLoss = profitAndLoss < 0 ? 0 : profitAndLoss;
  const tooltip = t(
    'dashboardTemplates:minimum_balance_level_required_to_complete_the_stage.',
  );

  return (
    <Card
      hoverable={false}
      className={classNames(
        'progress-cards',
        'progress-cards__card',
        'progress-cards__card--target',
      )}
    >
      <Flex vertical>
        <Flex justify={'space-between'}>
          <TextComponent weight={400} level={isMobile ? 5 : 3}>
            {t('dashboardTemplates:profit_target')}
          </TextComponent>
          <DashboardTooltip tooltipText={tooltip} />
        </Flex>
        <Flex align="baseline" wrap={'wrap'}>
          <TextComponent level={isMobile ? 3 : 2} weight={600}>
            <Statistic
              prefix={'$'}
              value={displayProfitAndLoss}
              precision={2}
            />
          </TextComponent>
          <TextComponent level={isMobile ? 7 : 3}>
            <Statistic prefix={'/$'} value={target} precision={0} />
          </TextComponent>
        </Flex>

        <Flex vertical>
          <ProgressSlider
            disabled
            min={0}
            max={target}
            value={profitAndLoss}
            trackColor={ThemeColors.colorAttention}
            primaryHandle={false}
            tooltip={{
              formatter: () => (
                <Statistic prefix={'$'} value={profitAndLoss} precision={2} />
              ),
            }}
          />

          <Flex justify="space-between">
            <Flex vertical>
              <TextComponent level={7} weight={600}>
                <Statistic prefix={'$'} value={base} precision={2} />
              </TextComponent>
              <TextComponent level={7}>
                {t('dashboardTemplates:initial_balance')}
              </TextComponent>
            </Flex>
            <Flex vertical align="end">
              <TextComponent level={7} weight={600}>
                <Statistic prefix={'$'} value={base + target} precision={2} />
              </TextComponent>
              <TextComponent level={7}>
                {t('dashboardTemplates:target')}
              </TextComponent>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
};
export default ProfitTargetTtp;
